const scrolltoTopWhenOpenBuilder = () => {
  const personalizeBtn = document.querySelector('.personalize-it--js');
  console.log(personalizeBtn);
  personalizeBtn.addEventListener('click', () => scrollTo(0,0));
}
addEventListener('DOMContentLoaded', scrolltoTopWhenOpenBuilder);

/** ==========================================================
 *  CPB: Edit flow (modifyProduct)
 *  - Delete old cart line
 *  - Let CPB re-add updated product
 *  ========================================================== */
(function () {
  console.log('Log in the beginning')
  if (window.__CPB_EDIT_FLOW_INIT__) return;
  window.__CPB_EDIT_FLOW_INIT__ = true;

  const params   = new URLSearchParams(window.location.search);
  const itemKey  = decodeURIComponent(params.get('modifyProduct') || '');
  
  if (!itemKey) return; // only run in edit mode

  const ADD_BTN_SELECTOR =
    '.cpb-actions-btn.cpb-add-to-cart-button, .cpb-add-to-cart-button';

  // Delete old line item by setting quantity to zero
  const removeOldLine = async (key) => {
    const body = new URLSearchParams({ id: key, quantity: '0' });
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body
    });
    if (!res.ok) throw new Error(await res.text());
  };

  let inProgress = false;

  // Intercept CPB add button before its handlers (capture phase)
  const onAddCapture = async (e) => {
    const btn = e.target.closest(ADD_BTN_SELECTOR);
    if (!btn) return;
    if (inProgress) return;
    inProgress = true;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    try {
      await removeOldLine(itemKey);

      // Allow CPB to run its normal add+redirect
      document.removeEventListener('click', onAddCapture, true);
      Promise.resolve().then(() => btn.click());
    } catch (err) {
      console.error('[CPB Edit] Failed to remove old line:', err);
      document.removeEventListener('click', onAddCapture, true);
      Promise.resolve().then(() => btn.click());
    } finally {
      // Re-enable interception for future clicks
      setTimeout(() => {
        document.addEventListener('click', onAddCapture, true);
        inProgress = false;
      }, 0);
    }
  };

  // Change button label
  const bind = () => {
    const btn = document.querySelector(ADD_BTN_SELECTOR);
    if (!btn) return false;
    const label = btn.querySelector('span') || btn;
    label.textContent = 'Update Cart';
    return true;
  };

  // Bind once when button appears
  const tryBind = () => {
    if (bind()) observer.disconnect();
  };

  const observer = new MutationObserver(tryBind);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBind, { once: true });
  } else {
    tryBind();
  }

  document.addEventListener('click', onAddCapture, true);
})();


// Sold out Personalize button function

(function() {
  async function getAvailable() {
    const path = window.location.pathname;
    const handle = path.split('/products/')[1]?.split(/[\\/?]/)[0];
    if (!handle) return true;

    const root = window.Shopify?.routes?.root || '/';
    const url = root + 'products/' + handle + '.js';

    try {
      const res = await fetch(url);
      if (!res.ok) return true;
      const product = await res.json();
      return product.available;
    } catch (e) {
      return true;
    }
  }

  function setSoldOut(btn) {
    if (btn.disabled && btn.textContent.includes('Sold')) return;

    btn.disabled = true;
    btn.innerHTML = 'Sold Out';
    btn.style.background = '#ffffff';
    btn.style.color = '#6e3e20';
    btn.classList.add('sold-out', 'button--disabled');

    console.log('The product is out of stock, blocking Personalize button');
  }

  async function runCheck() {
    const available = await getAvailable();
    if (!available) {
      const btn = document.querySelector('.personalize-it--js');
      if (btn) {
        setSoldOut(btn);
      }
    }
  }

  runCheck();

  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;
    runCheck();
    if (attempts >= 15 || document.querySelector('.personalize-it--js')?.disabled) {
      clearInterval(interval);
    }
  }, 600);

})();
